// extracted by mini-css-extract-plugin
module.exports = {"brand":"Styles_brand__JlDlS"};